<script setup>
import { useRouter } from "vue-router";

import MptLogoSingleSvg from "@/components/svg/MptLogoSingleSvg.vue";
import MptLogoSvg from "@/components/svg/MptLogoSvg.vue";
import AppEnv from "@/layout/AppEnv.vue";
import { useLayout } from "@/layout/composables/layout";

import AppMenu from "./AppMenu.vue";

const router = useRouter();

const { layoutState } = useLayout();

let timeout = null;

function onMouseEnter() {
  if (!layoutState.anchored) {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
    layoutState.sidebarActive = true;
  }
}

function onMouseLeave() {
  if (!layoutState.anchored) {
    if (!timeout) {
      timeout = setTimeout(() => (layoutState.sidebarActive = false), 300);
    }
  }
}

function onAnchorToggle() {
  layoutState.anchored = !layoutState.anchored;
  localStorage.setItem("sidebarAnchored", String(layoutState.anchored));
}

function navigateToHome() {
  router.push("/");
}
</script>

<template>
  <div class="layout-sidebar" @mouseenter="onMouseEnter()" @mouseleave="onMouseLeave()">
    <div class="sidebar-header">
      <a class="app-logo cursor-pointer" @click="navigateToHome">
        <MptLogoSvg class="app-logo-normal" />
        <MptLogoSingleSvg class="app-logo-single h-2rem" />
      </a>
      <button class="layout-sidebar-anchor" type="button" @click="onAnchorToggle"></button>
    </div>

    <AppEnv />

    <div ref="menuContainer" class="layout-menu-container">
      <AppMenu />
    </div>
  </div>
</template>
